import { useNavigate } from "@tanstack/react-router";

import { ExpandableSection } from "@/components/ExpandableSection/ExpandableSection";
import { HotelContactDetails } from "@/features/hotels/components/hotel/HotelContactDetails";
import { HotelFacilities } from "@/features/hotels/components/hotel/HotelFacilities";
import { HotelImages } from "@/features/hotels/components/hotel/HotelImages";
import { HotelName } from "@/features/hotels/components/hotels/HotelName";
import { HotelStars } from "@/features/hotels/components/hotels/HotelStars";
import type { FindHotelsOutputData } from "@/types/codegen";

interface HotelOverviewProps {
  hotel: FindHotelsOutputData;
}

export const HotelOverview = ({ hotel }: HotelOverviewProps) => {
  const navigate = useNavigate();

  return (
    <div className="section-card">
      <div className="flex w-full text-lg font-semibold text-text-primary">
        <HotelName name={hotel.name} />
      </div>
      <div className="mb-3 flex items-center">
        {!!hotel.stars && <HotelStars stars={hotel.stars} />}
      </div>
      <HotelImages
        hotel={hotel}
        onImageClick={() => {
          navigate({
            to: "/hotels/$id/details/images",
            params: { id: hotel.id },
          });
        }}
      />
      <ExpandableSection>
        <div className="text-sm text-text-primary">
          {hotel?.descriptions?.full || hotel?.descriptions?.short}
        </div>
      </ExpandableSection>

      <HotelFacilities hotel={hotel} />
      <HotelContactDetails hotel={hotel} />
    </div>
  );
};
